import React from "react";

import { ROUTE_TITLE } from "../misc";

export const FAQPage: React.FC<{}> = () => {
    document.title = ROUTE_TITLE.FAQ;
    return null;
};
